<template>
	<div class="page-implementers-company">
		<action-sidebar
		title="Empresas"
		:value="true"
		@close-modal="closeModal"
		>
		<v-tabs
		right
		v-model="tabsCompany"
		slider-color="cyan">
			<v-tab v-for="(item, index) in tabs" :key="index">
				{{item.name}}
			</v-tab>
		</v-tabs>
		<v-tabs-items v-model="tabsCompany">
			<v-tab-item>
				<app-table
					class="mt-4 px-2"
					selectable
					:check-all="checkAll"
					name="assign-company"
					:columns="columns"
					:rows="companies"
					:current-page="currentPage"
					:selected-value="selectedValue"
					:last-page="lastPage"
					@row-is-selected="rowIsSelected"
					@on-selected-all="allIsSelected"
					@on-search-event="onSearch"
					@on-page="changePage">
					<template slot="rows" slot-scope="props">
						<td class="is-not-selectable"
							v-show="showRow(columns, 1)">
							{{ props.row.ruc }}
						</td>
						<td v-show="showRow(columns, 2)">
							{{ props.row.nombreComercial }}
						</td>
						<td v-show="showRow(columns, 3)">
							{{ props.row.template ? props.row.template.data.items.data.name : null }}
						</td>
						<td v-show="showRow(columns, 4)">
							{{ props.row.template ? props.row.template.data.name : null }}
						</td>
					</template>
				</app-table>
			</v-tab-item>
			<v-tab-item>
				<app-table
					:check-all="checkAllDeallocated"
					selectable
					class="mt-4 px-2"
					name="assign-company"
					:columns="columns"
					:rows="companiesDeallocated"
					:current-page="currentPageDeallocated"
					:last-page="lastPageDeallocated"
					:selected-value="selectedValueDeallocated"
					@row-is-selected="rowIsSelectedDeallocated"
					@on-selected-all="allIsSelectedDeallocated"
					@on-page="changePageDeallocated"
					@on-search-event="onSearchDeallocated">
				<template slot="rows" slot-scope="props">
					<td class="is-not-selectable" 
					v-show="showRow(columns, 1)">
						{{ props.row.ruc }}
						</td>
						<td v-show="showRow(columns, 2)">{{ props.row.nombreComercial}}</td>
						<td v-show="showRow(columns, 3)">{{ props.row.template ? props.row.template.data.items.data.name : null }}</td>
						<td v-show="showRow(columns, 4)">{{ props.row.template ? props.row.template.data.name : null }}</td>
					</template>
				</app-table>
			</v-tab-item>
		</v-tabs-items>
		<section class="modal-filter-footer pt-3 pb-3">
			<div class="footer-container">
				<v-btn
					class="btn-action caption mr-1"
					color="pink"
					@click="closeModal">
					Cancelar
					<v-icon class="ml-2" size="18">close</v-icon>
				</v-btn>
				<v-btn
					class="btn-action caption ml-1"
					color="success"
					:disabled="disabledAssign(1)"
					@click="btnAssignCompany">
					Asignar
				</v-btn>
				<v-btn class="btn-action caption ml-1"
					color="success"
					:disabled="disabledDeallocated(0)"
					@click="btnDeallocated">
					Desasignar		
				</v-btn>
			</div>
		</section>
		</action-sidebar>
	</div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';

function disabledAssign(value) {
	return this.tabsCompany === value || this.dataSelected.length < 1;
}

function disabledDeallocated(value) {
	return this.tabsCompany === value || this.dataSelectedDeallocated.length < 1;
}

async function btnDeallocated() {
	const ids = this.dataSelectedDeallocated.map(p => p.id);
	const body = {
		companiesIds: ids,
	};
	try {
		await this.$http.delete(`implementers/${this.id}/companies`, { data: body });
		this.showNotification('Fueron desasignados correctamente');
		this.closeModal();
		this.loadDataDeallocated();
	} catch (error) {
		this.showError();
	}
}

async function btnAssignCompany() {
	const companiesIds = this.dataSelected.map(action => action.id);
	try {
		await this.$http.post(`implementers/${this.id}/companies`, { companiesIds });
		this.showNotification('Las compañias fueron asignados correctamente');
		this.closeModal();
		this.loadData();
	} catch (error) {
		this.showError();
	}
}

function rowIsSelected(row) {
	this.companies = this.selectIsRow(this.companies, this.selectedValue, row);
	this.checkAll = this.every(this.companies, this.selectedValue);
	this.dataSelected = this.companies.filter(r => r.flagSelected);
}

function rowIsSelectedDeallocated(row) {
	this.companiesDeallocated =
		this.selectIsRow(this.companiesDeallocated, this.selectedValueDeallocated, row);
	this.checkAllDeallocated = this.every(this.companies, this.selectedValueDeallocated);
	this.dataSelectedDeallocated = this.companiesDeallocated.filter(r => r.flagDeallocated);
}

function onSearch(value) {
	this.params.search = value ? value.trim() : null;
	this.loadData();
}

function onSearchDeallocated(search) {
	this.params.searchDeallocated = search ? search.trim() : null;
	this.loadDataDeallocated();
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.loadData();
}

function changePageDeallocated(page) {
	this.params.page = page;
	this.currentPageDeallocated = page;
	this.loadDataDeallocated();
}

function allIsSelectedDeallocated(checked) {
	this.checkAllDeallocated = checked;
	this.dataSelectedDeallocated = [];
	this.companiesDeallocated = this.companiesDeallocated.map((item) => {
		const newRowDeallocated = { ...item };
		newRowDeallocated.isSelected = checked;
		if (checked) {
			this.dataSelectedDeallocated.push(item);
		}
		return newRowDeallocated;
	});
	this.companiesDeallocated =
		this.selectIsRow(this.companiesDeallocated, this.selectedValueDeallocated, false, checked);
}

function allIsSelected(checked) {
	this.checkAll = checked;
	this.dataSelected = [];
	this.companies = this.companies.map((element) => {
		const newRow = { ...element };
		newRow.isSelected = checked;
		if (checked) {
			this.dataSelected.push(element);
		}
		return newRow;
	});
	this.companies = this.selectIsRow(this.companies, this.selectedValue, false, checked);
}

function created() {
	this.loadData();
	this.loadDataDeallocated();
}

async function loadDataDeallocated() {
	const params = {
		page: this.params.page,
		search: this.params.searchDeallocated,
		perPage: 20,
		isSelected: 1,
	};
	const response = await this.$http.get(`implementers/${this.id}/companies`, { params });
	this.companiesDeallocated = response.data.data;
	this.lastPageDeallocated = Number(response.headers['x-last-page']);
}

async function loadData() {
	const params = {
		isSelected: 0,
		page: this.params.page,
		perPage: 20,
		search: this.params.search,
	};
	const response = await this.$http.get(`implementers/${this.id}/companies`, { params });
	this.companies = response.data.data;
	this.lastPage = Number(response.headers['x-last-page']);
}

function data() {
	return {
		checkAll: false,
		checkAllDeallocated: false,
		columns: [
			{ id: 1, name: 'Ruc', value: 'ruc', checked: true, visible: true },
			{ id: 2, name: 'Nombre', value: 'name', checked: true, visible: true },
			{ id: 3, name: 'Rubro', value: 'rubro', checked: true, visible: true },
			{ id: 4, name: 'Template', value: 'template', checked: true, visible: true },
		],
		columnsAppoint: [
			{ id: 1, name: 'Ruc', value: 'ruc', checked: true, visible: true },
			{ id: 2, name: 'Nombre', value: 'name', checked: true, visible: true },
			{ id: 3, name: 'Compañia', value: 'company', checked: true, visible: true },
			{ id: 4, name: 'Rubro', value: 'rubro', checked: true, visible: true },
			{ id: 5, name: 'Template', value: 'template', checked: true, visible: true },
		],
		companies: [],
		companiesDeallocated: [],
		currentPage: 1,
		currentPageDeallocated: 1,
		dataSelected: [],
		dataSelectedDeallocated: [],
		lastPage: 0,
		lastPageDeallocated: 0,
		rows: [],
		rowsAppoint: [],
		selectedValue: 'flagSelected',
		selectedValueDeallocated: 'flagDeallocated',
		tabsCompany: null,
		tabs: [
			{
				id: 1,
				name: 'Asignar',
			},
			{
				id: 2,
				name: 'Asignados',
			},
		],
	};
}

function closeModal() {
	this.goTo('page-config-implementers');
}

export default {
	name: 'page-implementers-company',
	created,
	data,
	methods: {
		allIsSelected,
		allIsSelectedDeallocated,
		btnAssignCompany,
		btnDeallocated,
		changePage,
		changePageDeallocated,
		closeModal,
		disabledAssign,
		disabledDeallocated,
		loadData,
		loadDataDeallocated,
		rowIsSelected,
		rowIsSelectedDeallocated,
		onSearch,
		onSearchDeallocated,
	},
	components: {
		actionSidebar,
	},
	props: {
		id: {
			type: [Number, String],
		},
	},
};
</script>

<style lang="scss" scoped>
.content-tabs {
	display: flex;
	flex-direction: column;
}

.footer-container {
	display: flex;
	justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/implementers/page-implementers-company.vue